import { render, staticRenderFns } from "./SinglePointPacketEditor.vue?vue&type=template&id=0c5ffb4e&"
import script from "./SinglePointPacketEditor.vue?vue&type=script&lang=ts&"
export * from "./SinglePointPacketEditor.vue?vue&type=script&lang=ts&"
import style0 from "./SinglePointPacketEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports